import React from 'react'
import { useSelector } from 'react-redux'
import { Link, useLocation, useParams, useSearchParams} from "react-router-dom";
import { FormattedMessage, useIntl  } from 'react-intl';

import { Tabs } from 'antd';

import { USERS_PATH } from '../utils/constants';
import BreadcrumbHeader from './BreadcrumbHeader';
import ReportsFilter from './ReportsFilter';
import DetailedReport from './DetailedReport';
import UserReportGeneral from './UserReportGeneral';
import {getPrinterDetailedColumns} from './GetDetailedColumns';

const UserReport = (props) => {

    let params = useParams();
    const userId = parseInt(params['id'], 10);

    const location = useLocation();
    const intl = useIntl();

    const [searchParams] = useSearchParams();
    const serverId = searchParams.get("serverId")

    let filterData = useSelector(state => state.reportFilter);
    let users = useSelector(state => state.usersCache);
    let servers = useSelector(state => state.serversCache);
    
    if (!userId)
    {
        return(
            <div><h3>Bad user Id</h3></div>
        );
    }

    let userName = users[userId] ? users[userId] : "User id = " + userId;
    let serverName = (serverId && servers[serverId]) ? servers[serverId] : null

return (
        <div>
            <div className = "filter-report-picker">
                <ReportsFilter/>
            </div>
            <BreadcrumbHeader
                location = {location}
                objectLink = {userName}
                server = {serverName}
                rootPath = {USERS_PATH}
                pathName = "User"
            />
            <br/>
                <Tabs defaultActiveKey="1" type="card">
                    <Tabs.TabPane tab={intl.formatMessage({ id: "LeftMenu.Submenu.general" })} key="1">
                        <UserReportGeneral userId = {userId} filterData = {filterData}/>
                    </Tabs.TabPane>
                    <Tabs.TabPane tab={intl.formatMessage({ id: "Detailed" })} key="2">
                    <DetailedReport 
                            api_url = {"/job?userId=" + userId} 
                            columns = {getPrinterDetailedColumns()}
                            filterData = {filterData}
                        />
                    </Tabs.TabPane>
                </Tabs>
                <Link to={USERS_PATH}><FormattedMessage id="Back"/></Link>
        </div>);
}

export default UserReport;